import React, { FunctionComponent } from 'react'
import CenteredPage from '../../views/styled/CenteredPage/CenteredPage'
import { Space } from 'antd'
import { atIcon, atText } from '../../assets/logos'

const LoadingScreen: FunctionComponent<any> = () => (
  <CenteredPage>
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <Space direction={'vertical'}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {atIcon(true)}
        </div>
        {atText()}
      </Space>
    </div>
  </CenteredPage>
)

export default LoadingScreen
